import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import PatientForm from './PatientForm';
import Loader from '../../common/Loader';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import AppointmentHeader from '../Components/AppointmentHeader';

import { usePageView } from '../../../hocs/usePageView';
import useNavigateToPreviousPage from '../hooks/useNavigateToPreviousPage';
import { redirectBackToServiceOrVisitType } from '../../../utils/appointments/redirect-utils';
import { selectProfileFormInspectionFieldListErrors } from '../../../redux/appointmentForm/selectors';
import { enhance } from './enhance';

import styles from './styles.styl';

function AppointmentPatientInfo({ inspectPatient, loading, services }) {
  const { formatMessage } = useIntl();

  const errors = useSelector(selectProfileFormInspectionFieldListErrors);

  usePageView('Get Care | Patient Info');

  const { navigateToPrevPage } = useNavigateToPreviousPage();

  const handleBack = () => {
    if (navigateToPrevPage) {
      navigateToPrevPage();
      return;
    }

    redirectBackToServiceOrVisitType(services);
  };

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.patientInfo" />
      <AppointmentHeader
        titleClassName={styles.header}
        title="appointments.form.patientInfo"
        subtitle="appointments.form.patientInfo.subtitle"
        handleBack={handleBack}
      />
      <div>{loading && <Loader />}</div>
      <PatientForm
        formatMessage={formatMessage}
        onSubmit={inspectPatient}
        errors={errors}
      />
    </Fragment>
  );
}

AppointmentPatientInfo.propTypes = {
  inspectPatient: PropTypes.func,
  loading: PropTypes.bool,
  services: PropTypes.array,
};

export default enhance(AppointmentPatientInfo);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPatientInfo/index.jsx